import React from "react";
import CommonSendComponent from "../../components/CommonSendComponent";
import Menu from "../Menu";
import { SEND_CONFIGS } from "../../config/sendConfigs";

const SendDqrImage = () => {
  return (
    <>
      <Menu />
      <CommonSendComponent config={SEND_CONFIGS.dqrImage} />
    </>
  );
};

export default SendDqrImage;
